// src/pages/ServiceManagement/tabs/OverviewTab.jsx
import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Divider,
  Avatar
} from '@mui/material';
import {
  Apps as AppsIcon
} from '@mui/icons-material';

const OverviewTab = ({ service, onChange }) => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Service Overview
      </Typography>
      <Divider sx={{ mb: 3 }} />

      {/* Logo Preview */}
      <Box sx={{ mb: 3, display: 'flex', justifyContent: 'center' }}>
        <Avatar
          src={service.logo}
          sx={{ width: 100, height: 100 }}
        >
          <AppsIcon sx={{ fontSize: 50 }} />
        </Avatar>
      </Box>

      {/* Service Information */}
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Service Information
          </Typography>
          <Divider sx={{ mb: 2 }} />

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
              fullWidth
              label="Service Name"
              value={service.name || ''}
              onChange={(e) => onChange({ name: e.target.value })}
              helperText="Technical identifier for the service"
            />

            <TextField
              fullWidth
              label="Friendly Name"
              value={service.friendlyName || ''}
              onChange={(e) => onChange({ friendlyName: e.target.value })}
              helperText="Display name shown to users"
            />

            <TextField
              fullWidth
              label="Description"
              value={service.description || ''}
              onChange={(e) => onChange({ description: e.target.value })}
              helperText="Brief description of the service"
              multiline
              rows={3}
            />

            <TextField
              fullWidth
              label="Logo URL"
              value={service.logo || ''}
              onChange={(e) => onChange({ logo: e.target.value })}
              helperText="URL to the service logo image"
            />
          </Box>
        </CardContent>
      </Card>

      {/* Metadata */}
      <Card sx={{ mt: 3 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Metadata
          </Typography>
          <Divider sx={{ mb: 2 }} />

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Box>
              <Typography variant="caption" color="text.secondary" display="block">
                Service ID
              </Typography>
              <Typography variant="body1" fontWeight="500">
                {service.id}
              </Typography>
            </Box>

            <Box>
              <Typography variant="caption" color="text.secondary" display="block">
                UUID
              </Typography>
              <Typography variant="body1" fontFamily="monospace">
                {service.uuid}
              </Typography>
            </Box>

            <Box>
              <Typography variant="caption" color="text.secondary" display="block">
                Created At
              </Typography>
              <Typography variant="body1">
                {service.createdAt ? new Date(service.createdAt).toLocaleString() : 'N/A'}
              </Typography>
            </Box>

            <Box>
              <Typography variant="caption" color="text.secondary" display="block">
                Last Updated
              </Typography>
              <Typography variant="body1">
                {service.updatedAt ? new Date(service.updatedAt).toLocaleString() : 'N/A'}
              </Typography>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default OverviewTab;
